import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7747aeec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mainContainer" }
const _hoisted_2 = { class: "relative hidden tooltipContainer" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "absolute arrowLeft",
  style: { top: '1px', right: '-10px' }
}, null, -1))
const _hoisted_4 = {
  class: "absolute whitespace-nowrap bg-oaiGray-900 text-white px-2 py-1 rounded text-xs",
  style: { top: '-4px', right: '-10px', transform: 'translateX(100%)' }
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<circle cx=\"5.5\" cy=\"2.5\" r=\"1.5\" data-v-7747aeec></circle><circle cx=\"5.5\" cy=\"13.5\" r=\"1.5\" data-v-7747aeec></circle><circle cx=\"5.5\" cy=\"8\" r=\"1.5\" data-v-7747aeec></circle><circle cx=\"10.5\" cy=\"2.5\" r=\"1.5\" data-v-7747aeec></circle><circle cx=\"10.5\" cy=\"13.5\" r=\"1.5\" data-v-7747aeec></circle><circle cx=\"10.5\" cy=\"8\" r=\"1.5\" data-v-7747aeec></circle>", 6)
const _hoisted_11 = [
  _hoisted_5
]

import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardDragHandle',
  props: {
    iconClass: {}
  },
  setup(__props: any) {

const { t } = useI18n();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("dashboard.drag_me")), 1)
    ]),
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass(["w-4 h-4 vgl-item__drag-handle", _ctx.iconClass]),
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "#4B5563"
    }, _hoisted_11, 2))
  ]))
}
}

})